<template>
  <el-dialog
    :visible.sync="budgetPool"
    :close-on-click-modal="false"
    modal
    width="60%"
  >
    <el-table
      :data="subTableHeadConfig"
      v-if="subTableHeadConfig.length > 0"
      class="order-data-table ie-table"
    >
      <!-- <el-table-column label="预算池名称" :render-header="icons" > -->
      <el-table-column label-class-name="budgetClass" min-width="250px">
        <template slot="header">
          <div>
            <span style="margin-right: 2px; color: #cd1231">*</span>
            <span>预算池名称</span>
          </div>
        </template>
        <template slot-scope="{ row }">
          <!-- 让后端给noDeletion -->
          <!-- <el-input  v-model="row.name"  :disabled='row.noDeletion'></el-input> -->
          <el-input
            v-model.trim="row.typeName"
            :disabled="row.noDeletion"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="TR code" min-width="250px">
        <template slot="header">
          <div>
            <span style="margin-right: 2px; color: #cd1231">*</span>
            <span>TR code</span>
          </div>
        </template>
        <template slot-scope="{ row }">
          <el-select placeholder="请选择TR code"  v-model.trim="row.trCodeName" :disabled="!!row.typeId" filterable clearable>
            <el-option :label="item.trKhCodeName"  :value="item.trKhCodeName" v-for="item,index in trCodeList" :key="index"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="备注" min-width="250px">
        <template slot-scope="{ row }">
          <el-input v-model.trim="row.remark"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200px">
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="!scope.row.noDeletion"
            @click="delBudget(scope)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div v-else class="no-data">暂无预算池数据，请新增预算池</div>
    <el-button
      type="text"
      icon="el-icon-plus"
      @click="addBudget"
      style="width: 130px; margin: 0 auto"
      >新增预算池</el-button
    >
    <!-- budgetPool = false -->
    <span slot="footer">
      <el-button class="btn-reset" @click="reset">取消</el-button>
      <el-button class="btn-red" @click="confirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import budgetApi from '@/api/budget'
import baseApi from '@/api/base.js'
export default {
  name: 'maintenance-budget-pool',
  props: {},
  data () {
    return {
      subTableHeadConfig: [],
      saveSubTableHeadConfig: [],
      budgetPool: false,
      disabled: true,
      queryParam: {},
      logoState: false,
      delTypeIds: [], // 要删除得typeid
      trCodeList: [],
      clock: null
    }
  },
  watch: {
    // 子组件内部不能直接修改父组件数据 所以拿到父组件数据集后 统一 对 subTableHeadConfig修改
    // queryParam: {
    //   },
    //   immediate: true
    // }
  },
  created () {
  },
  methods: {
    show () {
      this.budgetPool = true
    },
    // 获取trCode 列表
    queryTrCodeList () {
      baseApi.queryTrCodeList().then(res => {
        if (res.data.resultCode === '0') {
          this.trCodeList = res.data.resultData.baseTrKhCodeList
          // this.trCodeList = res.data.resultData.baseTrKhCodeList.map(item => {
          //   item.trCode = item.trKhCode
          //   return item
          // })
        }
      })
    },
    // 新增
    addBudget () {
      this.subTableHeadConfig.push({
        typeName: '',
        remark: '',
        noDeletion: false,
        buCode: this.queryParam.orgCode,
        trCode: ''

      })
      this.logoState = this.subTableHeadConfig.filter(child => {
        if (child.typeName === '' || child.remark === '') {
          return true
        }
      })
    },
    // 编辑
    editorBudget (queryParam) {
      this.queryParam = queryParam
      console.log(queryParam, 'queryParam111')
      // 获取预算池数据
      let params = {
        buCode: this.queryParam.orgCode
      }
      budgetApi.getTableHeadConfig(params).then(res => {
        if (res.data.resultCode === '0') {
          this.subTableHeadConfig = res.data.resultData.budgetTypeList.map(item => {
            return { typeName: item.typeName, remark: item.remark, noDeletion: item.noDeletion === true, typeId: item.typeId, buCode: this.queryParam.orgCode, trCode: item.trCode, trCodeName: item.trCodeName }
          })
          this.queryTrCodeList()
        }
      })
    },
    // 删除
    delBudget (scope) {
      this.subTableHeadConfig.splice(scope.$index, 1)
      // 已经保存才调接口(保存才有typeid)
      if (scope.row.typeId) {
        this.delTypeIds.push(scope.row.typeId)
      }
    },
    // 确认
    confirm () {
      if (this.clock === null) {
        this.subTableHeadConfig.map(item => {
          item.trCode = item.trCodeName
          return item
        })
        let isValid = this.valideteBudgetPool()

        if (!isValid) return
        this.budgetPool = true
        if (this.delTypeIds.length > 0) {
          budgetApi.delBudget({ typeIds: this.delTypeIds }).then(res => {
            if (res.data.resultCode === '0') {
              this.delTypeIds = []
              budgetApi.confirm(this.subTableHeadConfig).then(res => {
                if (res.data.resultCode === '0') {
                  this.budgetPool = false
                  this.$emit('refresh', this.queryParam.orgCode)// 返回数值
                }
              }).catch(() => {
                this.budgetPool = false
              })
            }
          })
        } else {
          budgetApi.confirm(this.subTableHeadConfig).then(res => {
            if (res.data.resultCode === '0') {
              this.budgetPool = false
              this.$emit('refresh', this.queryParam.orgCode)// 返回数值
            }
          }).catch(() => {
            this.budgetPool = false
          })
        }
        this.clock = setTimeout(() => {
          this.clock = null
        }, 1000)
      }
    },
    reset () {
      this.budgetPool = false
    },
    // 预算池名称为空给提示
    valideteBudgetPool () {
      let isValid = true
      this.subTableHeadConfig.some(item => {
        if (!item.typeName) {
          isValid = false
          this.$message.warning('请填写预算池名称')
          return true
        }
        if (!item.typeId && !item.trCode) {
          isValid = false
          this.$message.warning('请选择trCode')
          return true
        }
      })
      return isValid
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog{
  min-width: 950px;
}
.no-data {
  text-align: center;
  margin-bottom: 20px;
}
::v-deep .el-dialog__header {
  border-bottom: 0px;
  padding: 0px;
}
::v-deep .order-data-table thead {
  color: #191919;
}
::v-deep .el-dialog__body {
  padding: 20px;
  display: flex;
  flex-direction: column;
}
::v-deep .el-button--text {
  color: #cd1231;
  margin-top: 0px;
}
::v-deep .el-dialog__footer {
  padding-top: 0;
  border: none;
}
::v-deep .el-dialog__footer span {
  display: flex;
  justify-content: space-evenly;
}
::v-deep .order-data-table {
  margin-bottom: 14px;
}
</style>
